<template>
  <v-text-field
    type="number"
    v-model="displayPrepayment"
    :label="$t('pricingPrepayment')"
    dense
    class="mt-4"
    :error-messages="errorMessages"
  ></v-text-field>
</template>

<script>
export default {
  name: "PrepaymentInput",

  props: ["value", "errorMessages"],

  computed: {
    displayPrepayment: {
      get: function (value) {
        return this.value * 100;
      },
      set: function (modifiedValue) {
        let newValue = modifiedValue * 0.01;
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
